(function () {
    'use strict';

    angular
        .module('reports')
        .controller('HandicapsReportCtrl', HandicapsReportCtrl);

    HandicapsReportCtrl.$inject = ['$scope', '$routeParams', 'reportsService', app.modules.common.services.functions];
    function HandicapsReportCtrl($scope, $routeParams, service, ggFunctions) {
        // Interface
        var vm = this, groupId = $routeParams.groupId;
        vm.data = null;
        vm.state = 'ready';
        vm.runReport = runReport;

        vm.toggle = toggle;
        vm.dateOptions = { minDate: new Date(2016, 1, 1), maxDate: new Date() };

        vm.startDate = new Date().addDays(-30);
        vm.endDate = new Date();

        // Implementation
        function complete() {
            ggFunctions.toggleProcessing(false);
        }

        function error(response) {
            vm.state = 'error';
        }

        function runReport() {
            if ($scope.form.$valid) {
                vm.data = null;
                vm.state = 'loading';
                ggFunctions.toggleProcessing(true);

                service
                    .fetchHandicapsReport(groupId, vm.startDate, vm.endDate)
                    .then(success)
                    .catch(error)
                    .finally(complete);
            }
            else
                $scope.form.$setTouched(); // <== Show all error messages
        }

        function success(response) {
            vm.state = 'loaded';
            vm.data = response.data;
        }

        function toggle(player) {
            player.expanded = !player.expanded;
        }
    }
})();
